module.exports = {"apiKey":"AIzaSyBQZTsl3DNU5oQSB4IccgMIv7lsYCNoPZw","authDomain":"smokeless-world-develop.firebaseapp.com","databaseURL":"https://smokeless-world-develop.firebaseio.com","projectId":"smokeless-world-develop","storageBucket":"smokeless-world-develop.appspot.com","messagingSenderId":"2062546517","appId":"1:2062546517:web:60821ad48b3f99d2","measurementId":"G-HVXRCRBT0X"}


//////////////////
// WEBPACK FOOTER
// ./src/firebase/config.json
// module id = 58
// module chunks = 0